import axios, { AxiosPromise } from 'axios';
import { IFaq } from '../../../@types/model/frequentlyAskedQuestions/faq';

export default class FrequentlyAskedQuestionsHttpService {
    public static getFaqData() : AxiosPromise<Array<IFaq>> {
        return axios.get(`${API_URL}/v1/Faq`);
    }

    public static addOrUpdateFaq(data : IFaq) : AxiosPromise<IFaq> {
        return axios.post(`${API_URL}/v1/Faq/PostFaq`, data);
    }
}
